import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

export default function useUsers(allowWatch) {
  const refUserListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true, thAttr: { width: '20' } },
    {
      key: 'user',
      sortable: true,
      label: 'Họ tên',
      // thAttr: { width: 250 },
    },
    {
      key: 'info',
      label: 'Thông tin chung',
      sortable: false,
      thAttr: { width: 150 },
    },
    {
      key: 'role',
      sortable: false,
      label: 'Vai trò',
      thAttr: { width: 150 },
    },
    {
      key: 'group',
      sortable: false,
      label: 'Nhóm',
      thAttr: { width: 150 },
    },
    // {
    //   key: 'online',
    //   sortable: false,
    //   label: 'Online',
    //   thAttr: { width: 80 },
    // },
    // {
    //   key: 'last_active',
    //   sortable: false,
    //   label: 'Truy cập',
    //   thAttr: { width: 80 },
    // },
    // {
    //   key: 'status',
    //   sortable: false,
    //   label: 'Trạng thái',
    //   thAttr: { width: 100 },
    // },
    {
      key: 'banned',
      sortable: false,
      label: 'Khóa',
      thAttr: { width: 50 },
    },
    {
      key: 'actions',
      label: 'Hành động',
      thAttr: { width: '100' },
      thClass: 'text-right',
      tdClass: 'text-right',
    },
  ];
  const loading = ref(false);
  const perPage = ref(30);
  const totalEntries = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 30, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const roleFilter = ref(null);
  const departmentFilter = ref(null);
  const statusFilter = ref(null);
  const onlineFilter = ref(null);
  const banFilter = ref(null);
  const positionFilter = ref(null);
  const isPaginate = ref(1);
  const roleOptions = ref([]);
  const departmentOptions = ref([]);
  const positionOptions = ref([]);
  const itemsData = ref([]);

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalEntries.value,
    };
  });
  const fetchUsers = () => {
    loading.value = true;
    store
      .dispatch('users/fetchUsers', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        department: departmentFilter.value,
        position: positionFilter.value,
        role: roleFilter.value,
        plan: departmentFilter.value,
        status: statusFilter.value,
        online: onlineFilter.value,
        ban: banFilter.value,
        isPaginate: isPaginate.value,
      })
      .then((response) => {
        if (response.status === 200) {
          const users = response.data.data.data;
          const { total } = response.data.data;
          itemsData.value = users;
          totalEntries.value = total;
          loading.value = false;
        }
      });
  };
  const fetchPositions = (ctx, callback) => {
    store.dispatch('users/fetchPositions', {}).then((response) => {
      if (response.status === 200) {
        const positions = response.data.data.data;
        positionOptions.value = response.data.data;
        if (callback !== undefined) callback(positions);
      }
    });
  };

  const fetchDepartments = (ctx, callback) => {
    store
      .dispatch('users/fetchDepartments', {
        isPaginate: 0,
      })
      .then((response) => {
        if (response.status === 200) {
          const departments = response.data.data.data;
          departmentOptions.value = response.data.data;
          if (callback !== undefined) callback(departments);
        }
      });
  };

  const fetchDepartmentTrees = () => {
    store.dispatch('users/fetchDepartments')
      .then(response => {
        if (response.status === 200) {
          const items = response.data.data;
          items.forEach((root) => {
            const item = {
              id: root.id,
              label: root.name,
              children: [],
            };
            if (root.childrens.length) {
              root.childrens.forEach((c1) => {
                const item1 = {
                  id: c1.id,
                  label: c1.name,
                  children: [],
                }
                if (c1.childrens.length) {
                  c1.childrens.forEach((c2) => {
                    const item2 = {
                      id: c2.id,
                      label: c2.name,
                      children: [],
                    }
                    if (c2.childrens.length) {
                      c2.childrens.forEach((c3) => {
                        const item3 = {
                          id: c3.id,
                          label: c3.name,
                          children: [],
                        }
                        if (c3.childrens.length) {
                          c3.childrens.forEach((c4) => {
                            const item4 = {
                              id: c4.id,
                              label: c4.name,
                              children: [],
                            }
                            if (c4.childrens.length) {
                              c4.childrens.forEach((c5) => {
                                const item5 = {
                                  id: c5.id,
                                  label: c5.name,
                                  children: [],
                                }
                                item4.children.push(item5);
                              })
                            }
                            item3.children.push(item4);
                          })
                        }
                        item2.children.push(item3);
                      })
                    }
                    item1.children.push(item2);
                  })
                }
                item.children.push(item1);
              })
            }
            departmentOptions.value.push(item);
          });
        }
      })
  };

  const fetchDepartmentTrees1 = () => {
    store.dispatch('users/fetchDepartments').then((response) => {
      if (response.status === 200) {
        const items = response.data.data;
        const result = [];
        items.forEach((item) => {
          result.push({ id: item.id, name: item.name });
          if (item.childrens) {
            item.childrens.forEach((schild) => {
              result.push({ id: schild.id, name: `--${schild.name}` });
              if (schild.childrens) {
                schild.childrens.forEach((schild2) => {
                  result.push({ id: schild2.id, name: `---${schild2.name}` });
                  if (schild2.childrens) {
                    schild2.childrens.forEach((schild3) => {
                      result.push({ id: schild3.id, name: `---${schild3.name}` });
                    });
                  }
                });
              }
            });
          }
        });
        departmentOptions.value = result;
      }
    });
  };
  const fetchRoles = () => {
    store
      .dispatch('users/fetchRoles', {
        isPaginate: 0,
      })
      .then((response) => {
        if (response.status === 200) {
          roleOptions.value = response.data.data;
        }
      });
  };

  const refetchData = () => {
    fetchUsers();
  };
  if (allowWatch === undefined) {
    watch([sortBy, isSortDirDesc, currentPage, perPage, searchQuery, departmentFilter, roleFilter, onlineFilter, statusFilter, banFilter], () => {
      refetchData();
    });
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*
  const onlineOptions = [
    { label: 'Offline', id: 0 },
    { label: 'Online', id: 1 },
  ];
  const statusOptions = [
    { label: 'Đợi duyệt', id: 2 },
    { label: 'Đã kích hoạt', id: 1 },
    { label: 'Chưa kích hoạt', id: 0 },
  ];
  const banOptions = [
    { label: 'Đã khóa', id: 1 },
    { label: 'Không khóa', id: 0 },
  ];
  const genderOptions = [
    { label: 'Nam', id: 1 },
    { label: 'Nữ', id: 2 },
    { label: 'Chưa xác định', id: 3 },
  ];

  const resolveUserRoleVariant = (role) => {
    if (role === 'subscriber') return 'primary';
    if (role === 'author') return 'warning';
    if (role === 'maintainer') return 'success';
    if (role === 'editor') return 'info';
    if (role === 'admin') return 'danger';
    return 'primary';
  };

  const resolveUserRoleIcon = (role) => {
    if (role === 'subscriber') return 'UserIcon';
    if (role === 'author') return 'SettingsIcon';
    if (role === 'maintainer') return 'DatabaseIcon';
    if (role === 'editor') return 'Edit2Icon';
    if (role === 'admin') return 'ServerIcon';
    return 'UserIcon';
  };
  const resolveUserStatusVariant = (status) => {
    if (status === 2) return 'warning';
    if (status === 1) return 'success';
    if (status === 0) return 'secondary';
    return 'primary';
  };
  const resolveUserBanVariant = (status) => {
    if (status === 1) return 'danger';
    if (status === 0) return 'secondary';
    return 'secondary';
  };
  const resolveUserOnlineVariant = (online) => {
    if (online === 1) return 'success';
    if (online === 0) return 'secondary';
    return 'primary';
  };
  const resolveUserRoleName = (val) => (val ? val.split(',') : '');
  const resolveUserStatusText = (val) => statusOptions.find((x) => x.id === val).label;
  const resolveUserBanText = (val) => (val ? 'Bấm để mở khóa' : 'Bấm để khóa lại');
  const resolveUserGenderText = (val) => genderOptions.filter((x) => x.id === val).label;
  const resolveUserDepartmentText = (val) => {
    const data = departmentOptions.value.find((x) => x.id === val)
    return data ? data.name : '';
  };
  const resolveUserPositionText = (val) => {
    const data = positionOptions.value.find((x) => x.id === val)
    return data ? data.name : '';
  };
  return {
    roleOptions,
    itemsData,
    loading,
    fetchUsers,
    fetchPositions,
    fetchDepartments,
    fetchDepartmentTrees,
    fetchRoles,
    tableColumns,
    perPage,
    currentPage,
    totalEntries,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    resolveUserStatusText,
    resolveUserGenderText,
    resolveUserRoleName,
    resolveUserOnlineVariant,
    resolveUserBanVariant,
    resolveUserBanText,
    resolveUserPositionText,
    resolveUserDepartmentText,
    refetchData,

    // Extra Filters
    roleFilter,
    departmentFilter,
    statusFilter,
    onlineFilter,
    statusOptions,
    genderOptions,
    onlineOptions,
    banFilter,
    positionFilter,
    banOptions,
    departmentOptions,
    positionOptions,
  };
}
